import React, { useEffect, useState } from "react";
import { Button, Card, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import { cookiesKeyNames } from "@revbox/common-fe";
import { saveNewPassword } from "../services/micro";
import { logosModule } from "../modules/logos";
import { useCookiesContext } from "../contexts/CookiesContext";

// http://localhost:3000/change-password?recovery_token=[<>]&token=[<>]&pub=[<>]
export default function ChangePassword() {
    const [newPassword, setNewPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const { updateCookiesProperty, getSkinMode } = useCookiesContext()

    const currentSkin = getSkinMode()
    const urlParams = new URLSearchParams(window.location.search)
    const pubParam = urlParams.get('pub')
    const advIdParam = urlParams.get('advId')
    const setPasswordParam = urlParams.get('set_password')
    const isOnboarding = urlParams.get('onboarding')
    const title = isOnboarding ? "Please enter your password." : "Please enter your new password."

    const publisherIdByAbbr = Number(pubParam);
    const [siteLogo, setSiteLogo] = useState(null);

    useEffect(() => {
        setSiteLogo(logosModule(publisherIdByAbbr, currentSkin));
    }, [publisherIdByAbbr, currentSkin]);

    useEffect(() => {
        return () => {
            updateCookiesProperty(cookiesKeyNames.publisherId, publisherIdByAbbr);
        }
    }, [publisherIdByAbbr]);

    const navigate = useNavigate()

    const recoveryToken = new URLSearchParams(window.location.search).get('recovery_token')
    const token = new URLSearchParams(window.location.search).get('token');

    const content = setPasswordParam || isOnboarding ? 'Set Password' : 'Change Password'

    const handleChangePassword = () => {
        if (newPassword !== confirmPassword) {
            toast.error('Password and Confirm Password are not matched.')
            return
        }

        if (!newPassword || !confirmPassword) {
            toast.error('Please enter your new password.')
            return
        }

        saveNewPassword(token, recoveryToken, newPassword)
            .then(res => {
                if (res.success) {
                    if (advIdParam) {
                        updateCookiesProperty(cookiesKeyNames.token, token, advIdParam);
                    } else {
                        updateCookiesProperty(cookiesKeyNames.token, token);
                    }

                    if (isOnboarding && advIdParam) {
                        toast.success('Your password has been changed successfully.')
                        window.location.href = '/pages/signin?pub=' + publisherIdByAbbr + '&advId=' + advIdParam
                    } else {
                        toast.success('Your password has been changed successfully.')
                        window.location.href = '/pages/signin?pub=' + publisherIdByAbbr
                    }
                } else {
                    toast.error(res.error)
                    return
                }
            })
            .catch(err => {
                toast.error('Failed to change your password.')
                console.log(err)
            })
    }

    return (
        <div className="page-sign stripes-bg">
            <Card className="card-sign">
                <Card.Header className="d-flex flex-column align-items-start">
                    <Link to="/" className="header-logo">
                        {siteLogo}
                    </Link>
                    <Card.Title className="text-center">{content}</Card.Title>
                    <Card.Text className="text-center">{title}</Card.Text>
                </Card.Header>
                <Card.Body>
                    <div className="mb-4">
                        <Form.Label className="d-flex justify-content-between">Password</Form.Label>
                        <Form.Control type="password" placeholder="Enter your new password" onChange={e => setNewPassword(e.target.value)} />
                    </div>
                    <div className="mb-4">
                        <Form.Label className="d-flex justify-content-between">Confirm Password</Form.Label>
                        <Form.Control
                            type="password"
                            placeholder="Enter your new password again"
                            onChange={e => setConfirmPassword(e.target.value)}
                        />
                    </div>
                    <Button variant="primary" className="btn-sign" onClick={handleChangePassword}>
                        {content}
                    </Button>
                </Card.Body>
                <Card.Footer>
                    Not you? <Link to="/pages/signin">Sign in with different account</Link>
                </Card.Footer>
            </Card>
        </div>
    )
}
